import { Injectable } from '@angular/core';

import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './auth.actions';
import { User } from '@angular/fire/auth/firebase';
import 'firebase/auth';
import { LeapOnboardingData } from 'src/app/public/leap/leap-onboarding.models';
import { LandscapePositions } from './auth.models';
import { BusinessSignUpRequestModel } from '@models/businessSignUpRequests';

@Injectable({
	providedIn: 'root',
})
export class AuthDispatch {
	@Dispatch()
	CheckEmailAndPassword = (
		email: string,
		password: string,
	): actions.CheckEmailAndPassword =>
		new actions.CheckEmailAndPassword({ email, password });

	@Dispatch()
	LoginWithEmailAndPassword = (
		email: string,
		password: string,
	): actions.LoginWithEmailAndPassword =>
		new actions.LoginWithEmailAndPassword({ email, password });

	@Dispatch()
	LoginWithMicrosoft = (): actions.LoginWithMicrosoft =>
		new actions.LoginWithMicrosoft();

	@Dispatch()
	SignInWithCustomToken = (token: string): actions.SignInWithCustomToken =>
		new actions.SignInWithCustomToken({ token });

	@Dispatch()
	LoginWithGoogle = (): actions.LoginWithGoogle =>
		new actions.LoginWithGoogle();

	@Dispatch()
	LogOut = (): actions.Logout => new actions.Logout();

	@Dispatch()
	SignUpEmailAndPassword = (
		email: string,
		password: string,
	): actions.SignUpEmailAndPassword =>
		new actions.SignUpEmailAndPassword({ email, password });

	@Dispatch()
	SetUserWithAuth = (): actions.SetUserWithAuth =>
		new actions.SetUserWithAuth();

	@Dispatch()
	SetUser = (user: User): actions.SetUser => new actions.SetUser({ user });

	@Dispatch()
	GetInvite = (inviteId: string, email: string): actions.GetInvite =>
		new actions.GetInvite(inviteId, email);

	@Dispatch()
	SetSignUpRequest = (
		request: BusinessSignUpRequestModel,
	): actions.SetSignUpRequest => new actions.SetSignUpRequest(request);

	@Dispatch()
	ResendEmailVerification = (): actions.ResendEmailVerification =>
		new actions.ResendEmailVerification();

	@Dispatch()
	SetLandscapePosition = (
		landscapePosition: LandscapePositions,
	): actions.SetLandscapePosition =>
		new actions.SetLandscapePosition(landscapePosition);

	@Dispatch()
	SetLoginChecked = (loginChecked: boolean) =>
		new actions.SetLoginChecked(loginChecked);

	@Dispatch()
	OnboardUserFromLeap = (
		onboardingData: LeapOnboardingData,
	): actions.OnboardUserFromLeap =>
		new actions.OnboardUserFromLeap(onboardingData);
}
